import React from 'react'

const HeaderSocials = () => {
  return (
    <div className="home__socials">
        <a href="https://www.instagram.com/ondigooo?igsh=MTBydDVhbzZvYW15MQ==" className="home__social-link" target="_blank"  rel="noopener noreferrer">
        <i class="fa-brands fa-instagram"></i>
        </a>

        <a href="https://x.com/george__ondigo" className="home__social-link" target="_blank"  rel="noopener noreferrer">
        <i class="fa-brands fa-x-twitter"></i>
        </a>

        <a href="https://github.com/Georgeondigo" className="home__social-link" target="_blank"  rel="noopener noreferrer">
        <i class="fa-brands fa-github"></i>
        </a>

        <a href="https://www.linkedin.com/in/george-ondigo/" className="home__social-link" target="_blank"  rel="noopener noreferrer">
        <i class="fa-brands fa-linkedin-in"></i>
        </a>

    </div>
  )
}

export default HeaderSocials